export default __webpack_public_path__ + "static/media/1004.34c659c5.png";